import API from '../../utils/Api'
import i18n from '@/plugins/i18n'

const api = new API('games')
const companiesApi = new API('companies')


const state = {
  current: null,
  list: [],
  loading: false,
  model: {
    name: "",
    gameVersion: "",
    user: ""
  }
}

const getters = {
  current (state) {
    return state.current
  },

  loading (state) {
    return state.loading
  },

  list (state) {
    return state.list
  },

  model (state) {
    return state.model
  },

  headers () {
    return [
      {
        text: i18n.t('games.code'),
        align: 'center',
        value: 'code'
      },
      {
        text: i18n.t('games.name'),
        align: 'center',
        value: 'name'
      },
      {
        text: i18n.t('games.version'),
        align: 'center',
        value: 'version'
      },
      {
        text: i18n.t('gameVersions.dd'),
        align: 'center',
        value: 'dd'
      },
      {
        text: i18n.t('games.createdBy'),
        align: 'center',
        value: 'createdBy'
      },
      {
        text: i18n.t('games.createdAt'),
        align: 'center',
        value: 'createdAtFormated'
      },
      {
        text: i18n.t('games.status'),
        align: 'center',
        value: 'statusName'
      },
      {
        text: i18n.t('games.favorites'),
        align: 'center',
        value: 'favLogo',
        logo: true,
        logoClick: true
      },
      {
        text: i18n.t('general.actions'),
        align: 'center',
        sortable: false
      }
    ]
  },

  status () {
    return [i18n.t('games.statusList.created'), i18n.t('games.statusList.open'), i18n.t('games.statusList.inProgress'), i18n.t('games.statusList.finished')]
  },

  assignableCompanies (state) {
    return state.current ? [...state.current.companies].filter((company) => company.assignable).sort((a, b) => a.level - b.level) : [] 
  },

  companies (state) {
    return state.current ? [...state.current.companies].sort((a, b) => a.level - b.level) : [] 
  }
}

const actions = {

  async getOne({ commit }, id) {
    try {
      commit('SET_loading', true)
      let res = await api.get(id)
      commit('SET_current', res.data)
      commit('SET_loading', false)
      return res.data
    } catch (error) {
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.games.getOneError') + error.message }, { root: true })
    }
  },

  async getAll({ commit }) {
    try {
      commit('SET_loading', true)
      let res = await api.getAll()
      commit('SET_list', res.data)
      commit('SET_loading', false)
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.games.getAllError') + error.message }, { root: true })
    }
  },

  async add({ commit }, data) {
    try {
      commit('SET_loading', true)
      let res = await api.post(data, '')
      commit('ADD_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.games.add') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.games.addError') + error.response.data }, { root: true })
      return false
    }
  },

  async update({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.put(params.id, params.data, "")
      commit('SET_current', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.games.update') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.games.updateError') + error.message }, { root: true })
      return false
    }
  },

  async updateFav({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.put(params.id, params.data, "/fav")
      commit('UPDATE_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.games.update') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.games.updateError') + error.message }, { root: true })
      return false
    }
  },

  async delete({ commit }, params) {
    try {
      commit('SET_loading', true)
      await api.deleteMany(params)
      commit('DELETE_list', params)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.games.delete') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.games.deleteError') + error.message }, { root: true })
      return false
    }
  },
  
  async deleteAndRefund({ commit }, id) {
    try {
      commit('SET_loading', true)
      await api.delete(id)
      commit('DELETE_list', [id])
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.games.delete') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.games.deleteError') + error.message }, { root: true })
      return false
    }
  },

  async pausePlayGame({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.put(params.id, params.data, "/pause-play")
      commit('SET_current', res.data)
      commit('SET_loading', false)
      if (params.data.suspended) {
        commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('games.pause') }, { root: true })
      } else {
        commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('games.play') }, { root: true })
      }
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.games.deleteError') + error.message }, { root: true })
      return false
    }
  },

  async startStop({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.put(params.id, params.data, "/change-status")
      commit('SET_current', res.data)
      commit('SET_loading', false)
      if (params.data.status == 2) {
        commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('games.stop') }, { root: true })
      } else {
        commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('games.start') }, { root: true })
      }
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.games.deleteError') + error.message }, { root: true })
      return false
    }
  },

  async debriefOnOff({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.put(params.id, params.data, "/change-status")
      commit('SET_current', res.data)
      commit('SET_loading', false)
      if (params.data.status == 2) {
        commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('games.debriefOff') }, { root: true })
      } else {
        commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('games.debriefOn') }, { root: true })
      }
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.games.deleteError') + error.message }, { root: true })
      return false
    }
  },

  async updateDemands({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await companiesApi.put(params.id, params.data, "")
      commit('UPDATE_game', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.games.updateDemands') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.games.updateDemandsError') + error.message }, { root: true })
      return false
    }
  },

  async simulation({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.put(params.id, params.data, "/simulation")
      commit('UPDATE_game', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.games.updateDemands') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.games.updateDemandsError') + error.message }, { root: true })
      return false
    }
  },

  SOCKET_playerUpdate ({commit}, val) {
    commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('socketMessages.' + val.message) + val.company.name }, { root: true })
    commit('UPDATE_game', val.company)
  }
}

const mutations = {

  DELETE_list(state, toDelete) {
    for (let i = 0; i < toDelete.length; i++) {
      for (let index = 0; index < state.list.length; index++) {
        if (state.list[index]._id === toDelete[i]) {
          state.list.splice(index, 1)
          break
        }
      }
    }
  },

  UPDATE_list(state, val) {
    for (let index = 0; index < state.list.length; index++) {
      if (state.list[index]._id === val._id) {
        state.list.splice(index, 1, val)
        break
      }
    }
  },

  ADD_list(state, val) {
    state.list.unshift(val)
  },

  SET_list(state, val) {
    state.list = val
  },

  SET_loading(state, val) {
    state.loading = val
  },

  SET_current(state, val) {
    state.current = val
  },

  UPDATE_game(state, val) {
    for (let index = 0; index < state.current.companies.length; index++) {
      if (state.current.companies[index]._id.toString() === val._id.toString()) {
        state.current.companies.splice(index, 1, val)
        break
      }
    }
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}